import axios from "axios";

const general = (formData) => {

  const url = formData?.inventory?.id?"inventories/edit":"inventories/add"
  const method = formData?.inventory?.id?"PUT":"POST"

  const response  = axios({
    url:url,
    data:formData,
    responseType: "json",
    method:method,
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  }).catch((error)=>{
    if(error?.response?.data){
      return {success: false, message:error.response.data.error}
    }
    return error.response.data    
  })
  return response
};

const manufacturing = (formData) => {
  let url = formData.id?"bom-mappings/edit":"bom-mappings/add"
  const response  = axios({
    url:url,
    data:formData,
    method:formData.id?"PUT":"POST",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  }).catch((error)=>{
    if(error?.response?.data){
      return {success: false, message:error.response.data.error}
    }
    return error.response.data    
  })
  return response
};

const bulkProcessMapping = (formData) => {

  const response  = axios({
    url:"process-mappings/bulk-add",
    data:formData,
    method:"POST",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  }).catch((error)=>{
    if(error?.response?.data){
      return {success: false, message:error.response.data.error}
    }
    return error.response.data    
  })
  return response
};

const gst = (formData) => {

  const response  = axios({
    url:"inventories/add",
    data:formData,
    method:"POST",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  })
  return response
};

const tds = (formData) => {

  const response  = axios({
    url:"inventories/add",
    data:formData,
    method:"POST",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  })
  return response
};

const tcs = (formData) => {

  const response  = axios({
    url:"inventories/add",
    data:formData,
    method:"POST",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  })
  return response
};

const inventoryList = (data) => {
  let params = new URLSearchParams(data).toString();
  const url = "inventories/list?"+params
  const response  = axios({
    url:url,
    responseType: "json",
    method:"GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response.data;
  }).catch((error)=>{
    if(error?.response?.data){
      return {success: false, message:error.response.data.error}
    }
    return error.response.data    
  })
  return response
};

const uomByInventoryId = (inventoryId) => {

  const response  = axios({
    url:"/uoms/"+inventoryId,
    method:"GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response) => {
    return response.data
  })
  return response

}

const invtService = {
  gst,
  tds,
  tcs,
  general,
  bulkProcessMapping,
  inventoryList,
  manufacturing,
  uomByInventoryId
};
  
export default invtService;